import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore } from "@pages/Kiosk/store";

export function TicketNumberMessageFooter(): JSX.Element {
    const {
        project: {
            template: {
                pages: {
                    ways: { finalMessage },
                },
            },
        },
        customerLanguage,
    } = useSnapshot(kioskStore);

    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{
                font: "normal 55px/20px Segoe UI",
                height: "300px",
            }}
        >
            {((finalMessage as PageType).footer as FooterType)
                .ticketNumberMessage.active === true
                ? ((finalMessage as PageType).footer as FooterType)
                      ?.ticketNumberMessage.languages[customerLanguage.name]
                      ?.defaultContent !== undefined
                    ? ((finalMessage as PageType).footer as FooterType)
                          ?.ticketNumberMessage.languages[customerLanguage.name]
                          .content
                    : null
                : null}
        </div>
    );
}
